import styled from '@emotion/styled';
import { nafColor } from '@nafcore/theme';
import { radius } from '@naf/theme';

export const StyledA = styled.a`
  display: flex;
  width: 100%;
  height: 100%;
  text-decoration: none;

  /* The card sizes to its content, so let it fill the grid cell. */
  > * {
    flex: 1;
  }

  &:hover {
    color: ${nafColor.signature.black};
  }

  /* The Simba card is not focusable when nested in a link, so the link owns the ring. */
  &:focus-visible {
    outline: 2px solid ${nafColor.signature.black};
    outline-offset: 2px;
    border-radius: ${radius.s};
  }
`;
